<template>
  <transition name="showHeader">
    <div v-if="visible" class="header-animat">
      <a-layout-header
          v-if="visible"
          :class="['ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
          :style="{ padding: '0' }"
      >
        <div v-if="mode === 'sidemenu'" class="header">
          <span @click="toggle">
            <template v-if="device==='mobile'">
              <MenuFoldOutlined v-if="collapsed" class="trigger"/>
              <MenuUnfoldOutlined v-else class="trigger"/>
            </template>
            <template v-else>
              <MenuUnfoldOutlined v-if="collapsed" class="trigger"/>
              <MenuFoldOutlined v-else class="trigger"/>
            </template>
          </span>
          <ReloadOutlined class="trigger" style="" @click="refreshPage"/>
          <UserMenu />
        </div>
      </a-layout-header>
    </div>
  </transition>
</template>

<script>
import {computed, ref} from "vue";
import {settingStore} from "@/store/setting";
import { MenuFoldOutlined, MenuUnfoldOutlined,ReloadOutlined } from '@ant-design/icons-vue';
import UserMenu from "@/components/Tools/UserMenu";

export default {
  name: "GlobalHeader",
  components: {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    ReloadOutlined,
    UserMenu,
  },
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  setup(props, {emit}) {
    const visible = ref(true)
    const userStore = settingStore();
    const sidebarOpened = computed(() => userStore.sidebarOpened);
    const toggle = () => {
      emit('toggle')
    };
    const refreshPage = () => {
      emit('refresh')
    }
    return {
      visible,
      toggle,
      refreshPage,
      sidebarOpened,
    }
  }
}
</script>

<style scoped>

</style>